/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Categories1
 */
export interface Categories1 {
}

/**
 * Check if a given object implements the Categories1 interface.
 */
export function instanceOfCategories1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Categories1FromJSON(json: any): Categories1 {
    return Categories1FromJSONTyped(json, false);
}

export function Categories1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Categories1 {
    return json;
}

export function Categories1ToJSON(value?: Categories1 | null): any {
    return value;
}

